import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Box, { BoxProps } from '@mui/material/Box';

import { RoomNameWithCapacity_room$key } from '__generated__/RoomNameWithCapacity_room.graphql';

type Props = BoxProps & {
  room: RoomNameWithCapacity_room$key;
};

const RoomNameWithCapacity: FC<Props> = ({ room, ...props }) => {
  const { nameString, capacity } = useFragment(
    graphql`
      fragment RoomNameWithCapacity_room on Room {
        nameString
        capacity
      }
    `,
    room
  );

  return (
    <Box component="span" {...props}>
      {nameString} {capacity && capacity > 0 ? `(${capacity})` : ''}
    </Box>
  );
};

export default RoomNameWithCapacity;
